import { sendCustomRequest } from "../../exports/rum";
import { get } from "../../exports/toggle";

declare global {
  interface Window {
    __OTTO_BROWSER_IS_UNSUPPORTED: boolean | undefined;
    __OTTO_BROWSER_IS_DEPRECATED: boolean | undefined;
    __OTTO_BROWSER_UNSTABLE_UA_DATA: Record<string, string> | undefined;
  }
}

try {
  if (get("ASSETS_BROWSER_SUPPORT_STATE", true)) {
    if (window.__OTTO_BROWSER_IS_UNSUPPORTED) {
      sendCustomRequest("BrowserSupport", {
        group: "unsupported",
        ...window.__OTTO_BROWSER_UNSTABLE_UA_DATA,
      });
    } else if (window.__OTTO_BROWSER_IS_DEPRECATED) {
      sendCustomRequest("BrowserSupport", {
        group: "partiallySupported",
        ...window.__OTTO_BROWSER_UNSTABLE_UA_DATA,
      });
    }
  }
} catch (e) {
  /*       */
}
